<template>
  <responsive-modal v-model="visible">
    <div class="tool-modal-spedy p-5">
      <button class="btn text-secondary close" @click="visible = false">
        <i class="icon-x" />
      </button>
      <div>
        <strong>
          Integração Spedy
        </strong>
      </div>
      <div class="d-flex align-items-center mb-5">
        <small class="text-dark flex-fill mt-3">
          <a
            target="_blank"
            href="https://spedy.com.br/"
            class="text-primary font-weight-bold text-decoration-none"
          >
            Conheça o Spedy
          </a>
        </small>
      </div>
      <hr />
      <action-dispatcher
        action="integration/getCoproducerProducts"
        :parameters="{ limit: 500 }"
      >
        <form-group
          :disabled="form.id != null"
          slim
          select
          id="product-select"
          label="Nome do produto"
          v-model="form.product_id"
          :errors="errors.product_id"
          placeholder="Selecionar produto..."
          :options="
            coproducerProducts.map(product => ({
              id: product.product_id,
              name: product.product_name
            }))
          "
        />
      </action-dispatcher>
      <form-group
        label="Descrição da integração (Opcional)"
        id="description"
        v-model="form.description"
        :errors="errors.description"
        placeholder="Digite a descrição da integração..."
      />
      <form-group
        id="token"
        label="Token"
        v-model="form.token"
        placeholder="Digite o token da integração..."
        :errors="errors.token"
      />
      <div class="d-flex justify-content-center mt-5">
        <button
          class="btn btn-primary"
          :disabled="!isValid"
          :class="{
            'btn-secondary border-secondary': !isValid
          }"
          @click="submit"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import documentValidation from "@/mixins/documentValidation";
import { mapState } from "vuex";
export default {
  mixins: [documentValidation],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(["product_id", "token", "status", "description"]),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      } else {
        this.validateCNPJ();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
      }
    }
  },
  computed: {
    ...mapState("integration", ["coproducerProducts"]),
    isValid() {
      return this.form.product_id && this.form.token && this.validDocument;
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    onSuccess() {
      this.loading = false;
      this.$message.success("A integração foi salva!");
      this.$emit("update-list");
      this.clear();
      this.visible = false;
    },
    submit() {
      this.loading = true;

      let data = {
        ...this.form
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, data)
        .then(this.onSuccess)
        .catch(error => {
          this.$message.error("Erro ao salvar integração");
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-spedy {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  button {
    i {
      font-size: 28px;
    }
  }
}
</style>
